export default {"src":"/_next/static/media/kaba_suji.99ab5cd5.gif","height":747,"width":997};